import { List, ListItem, makeStyles } from '@material-ui/core';

const AddMultipleItemsModalSummary = ({ totalExpenses, totalIncomes }) => {
    const useStyles = makeStyles(() => ({
        total: {
            display: 'flex',
            width: '25%',
        },
    }));

    const classes = useStyles();

    return (
        <List className={classes.total} dense>
            <ListItem data-testid="total-income">Total incomes: {totalIncomes}</ListItem>
            <ListItem data-testid="total-expense">Total expenses: {totalExpenses}</ListItem>
        </List>
    );
};

export default AddMultipleItemsModalSummary;
